import { render, staticRenderFns } from "./ViewCampaignOpenReportPopUp.vue?vue&type=template&id=04b6dc5b&scoped=true&"
import script from "./ViewCampaignOpenReportPopUp.vue?vue&type=script&lang=js&"
export * from "./ViewCampaignOpenReportPopUp.vue?vue&type=script&lang=js&"
import style0 from "./ViewCampaignOpenReportPopUp.vue?vue&type=style&index=0&id=04b6dc5b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b6dc5b",
  null
  
)

export default component.exports